import config from 'Config';

/**
 * Determine if we randomly sample API response for performance measurement or not
 * @return {boolean}        should sample
 */
export function shouldSamplePerformance() {
  if (__TEST__) {
    return false;
  }
  return Math.random() < config?.perf?.apiSamplingRate;
}
